import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import XtSvg from "@/components/Xt/Svg";
interface P4Props extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const P4: React.FC<P4Props> = ({ className }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  useEffect(() => {
    store.user.updateState({ canEnterprise: false });
  }, []);
  return (
    <div className={cx(styles["page-account-enterprise-p4"], className)}>
      <XtSvg src={require("@/assets/icon-svg/account/otc_attestation_success_ico.svg")} size={64} color="#B9F78A" />
      <div>{t("ent.submitSuccess")}</div>
      <p>{t("ent.submitSuccessTip")}</p>
    </div>
  );
};
export default observer(P4);
